import { useMemo } from 'react'

export interface UrlParams {
  // Filter params
  mProgram: number | null
  degreeInterest: number | null
  // Tracking params
  mPubID: string | null
  mPubCampaignID: string | null
  sub1: string | null
  sub2: string | null
  sub3: string | null
  // Google Ads parameters
  campaignid: string | null
  targetid: string | null
  matchtype: string | null
  adgroupid: string | null
  device: string | null
  gclid: string | null
  // Custom headline parameter
  t1: string | null
}

export function useUrlParams(): UrlParams {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search)

    const parseNum = (key: string): number | null => {
      const val = params.get(key)
      if (val === null) return null
      const num = parseInt(val, 10)
      return isNaN(num) ? null : num
    }

    // Get Google Ads parameters
    const campaignid = params.get('campaignid')
    const targetid = params.get('targetid')
    const matchtype = params.get('matchtype')
    const adgroupid = params.get('adgroupid')
    const device = params.get('device')
    const gclid = params.get('gclid')

    // Build sub1, sub2, sub3 from Google Ads parameters if they exist
    // sub1 format: {campaignid}_{targetid}_main
    const sub1 =
      params.get('sub1') ||
      (campaignid && targetid ? `${campaignid}_${targetid}_main` : null)

    // sub2 format: {matchtype}_{adgroupid}_{device}
    const sub2 =
      params.get('sub2') ||
      (matchtype && adgroupid && device
        ? `${matchtype}_${adgroupid}_${device}`
        : null)

    // sub3 format: {gclid}
    const sub3 = params.get('sub3') || gclid

    return {
      mProgram: parseNum('mProgram'),
      degreeInterest: parseNum('degreeInterest'),
      mPubID: params.get('mPubID'),
      mPubCampaignID: params.get('mPubCampaignID'),
      sub1,
      sub2,
      sub3,
      campaignid,
      targetid,
      matchtype,
      adgroupid,
      device,
      gclid,
      t1: params.get('t1'),
    }
  }, [])
}
